import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SearchVirtualKeyboardContainer = styled.div<React.CSSProperties>`
  width: ${250 * Screen.widthRatio}px;
`;

export default SearchVirtualKeyboardContainer;
